import * as Dialog from '@radix-ui/react-dialog';
import type { PropsWithChildren } from 'react';

import { ModalOnPointerDownOutsideHandler } from 'src/common/primitives/Modal/ModalOnPointerDownOutsideHandler';

interface SlideInDialogProps extends PropsWithChildren {
  ariaTitle: string;
  open?: boolean;
  testId?: string;
  onClose?: () => void;
  setOpen: (open: boolean) => void;
}

export function SlideInDialog({
  ariaTitle,
  open,
  testId,
  onClose,
  setOpen,
  children,
}: SlideInDialogProps) {
  return (
    <Dialog.Root
      open={open}
      onOpenChange={(newValue) => {
        setOpen(newValue);
        if (!newValue) {
          onClose?.();
        }
      }}
    >
      <Dialog.Portal>
        <Dialog.Content
          className="fixed inset-0 z-20 h-full w-full translate-x-0 overflow-hidden data-[state=open]:animate-tripFormSlideIn data-[state=closed]:animate-tripFormSlideOut"
          onPointerDownOutside={ModalOnPointerDownOutsideHandler}
          aria-describedby={undefined}
          data-testid={testId}
        >
          {ariaTitle ? (
            <Dialog.Title className="sr-only" asChild>
              <span>{ariaTitle}</span>
            </Dialog.Title>
          ) : null}
          <div className="pointer-events-auto relative flex h-full flex-col overflow-y-auto bg-white p-4 shadow-xl">
            {children}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
